"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_DOWNLOAD_URL = void 0;
var helpers_1 = require("../../client/helpers");
exports.GET_DOWNLOAD_URL = "\n  query GetDownload($id: ID!) {\n    video(filter: { id: $id }) {\n      download(type: CONTENT) {\n        entity {\n          url\n        }\n      }\n    }\n  }\n";
//# sourceMappingURL=queries.js.map